import { render, staticRenderFns } from "./Odontologo.vue?vue&type=template&id=9167296a&scoped=true&"
import script from "./Odontologo.vue?vue&type=script&lang=js&"
export * from "./Odontologo.vue?vue&type=script&lang=js&"
import style0 from "./Odontologo.vue?vue&type=style&index=0&id=9167296a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9167296a",
  null
  
)

export default component.exports